module.exports = __webpack_public_path__ + "img/tool_eraser_active.ea462da9.png";